import React from 'react';

interface AdvisorAvatarProps {
  name: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const AdvisorAvatar: React.FC<AdvisorAvatarProps> = ({ 
  name, 
  size = 'medium', 
  className = '' 
}) => {
  // Generate consistent color from name hash
  const generateColor = (name: string) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const colors = [
      'from-orange-400 to-orange-600',
      'from-purple-400 to-purple-600',
      'from-blue-400 to-blue-600',
      'from-green-400 to-green-600',
      'from-red-400 to-red-600',
      'from-yellow-400 to-yellow-600',
      'from-pink-400 to-pink-600',
      'from-indigo-400 to-indigo-600',
    ];
    
    return colors[Math.abs(hash) % colors.length];
  };

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const sizeClasses = {
    small: 'w-8 h-8 text-sm',
    medium: 'w-12 h-12 text-lg',
    large: 'w-16 h-16 text-xl'
  };

  const colorClass = generateColor(name);

  return (
    <div 
      className={`
        ${sizeClasses[size]} 
        rounded-full 
        bg-gradient-to-br ${colorClass}
        flex items-center justify-center 
        font-bold text-white 
        shadow-lg
        ${className}
      `}
    >
      {getInitials(name)}
    </div>
  );
};